// Packages does not support in policy UI
export const SHOW_POLICIES_IN_PACKAGES = false;